var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225.2 221.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e9e9ea;\n      }\n\n      .cls-2 {\n        fill: #f8d164;\n      }\n\n      .cls-3 {\n        fill: #dcddde;\n      }\n\n      .cls-4 {\n        fill: #f1f2f2;\n      }\n\n      .cls-5 {\n        fill: #c08e2c;\n        isolation: isolate;\n        opacity: .7;\n      }\n\n      .cls-6 {\n        fill: #e1ad3b;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #e0e1e2;\n      }\n\n      .cls-9 {\n        fill: #cdcfd0;\n      }\n\n      .cls-10 {\n        fill: #dadbdc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M146.57,10.33s27.09,9.93,39.78,20.71c12.69,10.77,28.96,26.51,34.87,44.68,5.92,18.17,5.99,44.95-4.9,67.84-7.06,14.82-25.06,35.96-35.96,47.95-11.54,12.69-27.47,21.41-44.41,25.88-23.7,6.27-47.13,5.18-65.93-2.45-17.88-7.26-44.03-23.04-57.48-46.22C-.55,146.19.45,121.85.45,121.85l76.78,77.87,83.92-19.86,42.46-49.91s-42.61-89.6-43.48-90.48c-8.47-8.6-14.38-21.78-14.38-21.78l.82-7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M134.31,6.79c-10.63-3.27-17.71-3.95-27.52-3.27s-17.84,1.63-30.38,6.81c9.43-2.36,15.44-.94,28.03-1.12,11.87-.17,27.12,5.41,29.86-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.4,97.24c1.36,33.51-12.26,49.86-25.34,66.47-13.08,16.62-32.4,41.51-70.29,47.68-35.14,5.72-65.57-5.76-87.45-24.52C11.44,167.26,3.27,148.68.54,125.57s5.34-44.01,13.08-59.66c6.46-13.08,11.89-22.62,23.97-34.6,10.35-10.26,26.15-17.35,38.14-20.98C86.74,7,120.14-.02,157.57,20.06c32.42,17.39,58.25,38.25,59.83,77.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.26,24.26c.74,2.68-3.79,5.66-10.74,10.15-8.21,5.3-16.29,12.89-24,24.03-6.79,10.56-10,16.06-14.38,15.17s.02-10.07,5.9-19.69c6.21-10.14,12.78-17.62,27.98-26.55,10.4-6.11,14.5-5.78,15.25-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M72.36,23.24c.49,1.54-3.39,3.87-10.65,8.4-8.9,5.56-17.38,13.68-23.82,22.73-7.91,11.8-9.82,17.77-12.75,16.88-3.98-1.21.91-10.54,6.63-19.72,6.02-9.67,11.12-16.46,19.81-22.45,8.69-5.99,19.64-9.42,20.79-5.85h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 20.87,
    cy: 86.77,
    r: 7.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 18.3,
    cy: 85.83,
    r: 5.09
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 109.47,
    cy: 203.45,
    r: 14.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 106.34,
    cy: 200.98,
    r: 10.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 104.37,
    cy: 199.61,
    r: 5.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 139.93,
    cy: 192.29,
    r: 9.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 137.8,
    cy: 190.61,
    r: 7.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 136.43,
    cy: 188.98,
    r: 4.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 49.26,
    cy: 178.35,
    r: 10.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.69,
    cy: 175.85,
    r: 8.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 46.62,
    cy: 173.83,
    r: 4.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 209.52,
    cy: 84.88,
    r: 11.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 206.53,
    cy: 83.52,
    r: 9.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 204.31,
    cy: 82.89,
    r: 4.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 105.43,
    cy: 103.13,
    r: 66.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 111.43,
    cy: 109.13,
    r: 66.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M154.52,57.9c11.46,12,18.5,28.24,18.5,46.14,0,36.92-29.93,66.86-66.86,66.86-17.06,0-32.61-6.4-44.43-16.91,12.25,13.56,29.98,22.09,49.69,22.09,36.98,0,66.95-29.97,66.95-66.95,0-20.56-9.28-38.95-23.86-51.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.89,109.95c-13.46,13.46-35.51,13.91-44.79,6.17-10.91-9.11-10.17-32.73,1.54-47.74,11.42-14.63,32.85-19.38,46.84-6.17,13.99,13.21,10.27,33.88-3.59,47.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 134.4,
    cy: 14.21,
    rx: 14.54,
    ry: 14.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 132.25,
    cy: 15.67,
    r: 12.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 131.17,
    cy: 15.89,
    r: 6.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 129.2,
    cy: 14.81,
    r: 5.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.94,77.18c.25-1.38,2.91-3.02,8.84-1.28s6.51,8.49,6.98,10.93,3.37,16.4,5,25.47c1.4-4.07,5.35-20.35,7.44-23.14s5.12-4.42,8.72-4.07c3.6.35,6.43,1.77,7.67,6.05,2.67,9.19,9.19,28.72,12.21,36.17.23-6.98.47-29.65.47-34.65s-.35-18.49-.93-25.23c-.25-2.92-.7-7.91.47-9.42s3.03-3.53,8.72-2.21c5,1.16,4.19,6.05,4.19,9.88,0,7.68.35,29.3.35,35.7s1.61,42.91,1.51,45.93c-.12,3.49-2.42,7.73-5,8.84-3.26,1.4-7.04,1.53-10.7-1.4-4.07-3.26-9.77-15.23-13.37-26.4-1.29-3.99-5.7-16.51-7.91-20.93-.58,5.35-2.09,14.77-3.02,24.19-.87,8.82-1.69,22.36-2.79,24.42-1.74,3.26-6.16,5.23-9.88,5.7s-6.74-.7-7.09-7.67c-.35-6.98-3.06-30.7-3.72-36.28-1.4-11.74-3.37-22.91-5.35-30.23-.99-3.68-3.37-7.09-2.79-10.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82.47,121.15c.99,8.61,3.03,26.91,3.33,32.9.35,6.98,3.51,8.12,7.09,7.67,3.72-.47,8.14-2.44,9.88-5.7,1.11-2.06,1.92-15.6,2.79-24.42.64-6.5,1.56-12.99,2.26-18.16-7.69,5.69-17.11,8.03-25.35,7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M144.06,101.37c0-6.4-.35-28.02-.35-35.7,0-3.84.81-8.72-4.19-9.88-5.7-1.32-7.56.7-8.72,2.21-1.16,1.51-.72,6.5-.47,9.42.58,6.74.93,20.23.93,25.23s-.23,27.68-.47,34.65c-2.41-5.94-7.05-19.59-10.18-29.53-2.11,4.36-5.06,8.51-8.73,12.18-.5.5-1.02.98-1.55,1.45,2.27,5.6,5.16,13.84,6.16,16.94,3.6,11.16,9.3,23.14,13.37,26.4,3.66,2.93,7.44,2.79,10.7,1.4,2.59-1.11,4.88-5.35,5-8.84.1-3.02-1.51-39.54-1.51-45.93Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW);
export default __webpack_public_path__ + "static/media/w.775046dc565b1e859f37af6ac85a45d2.svg";
export { ForwardRef as ReactComponent };